import React from 'react';
import { Helmet } from 'react-helmet-async';

type HeadProps = {
  title?: string;
  description?: string;
  ogpTitle?: string;
  ogpDescription?: string;
  ogpImageUrl?: string;
  ogpUrl?: string;
};

const OwnerHead: React.FC<HeadProps> = ({ title }) => {
  return (
    <Helmet>
      <title>{title ? `${title} | Cafect` : 'Cafect'}</title>
    </Helmet>
  );
};

export default OwnerHead;
